import { render, staticRenderFns } from "./mytabs.vue?vue&type=template&id=38b04d0e&scoped=true"
import script from "./mytabs.vue?vue&type=script&lang=js"
export * from "./mytabs.vue?vue&type=script&lang=js"
import style0 from "./mytabs.vue?vue&type=style&index=0&id=38b04d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b04d0e",
  null
  
)

export default component.exports